import { httpClient } from '../http/httpClient'

export interface CreateSellerBody {
  name: string
  cpf: string
  email: string
  phone: string
  password: string
  birthDate?: string
  instagram?: string
  marketing?: boolean
  rg?: {
    number: string
    organ: string
    uf: string
  }
  address: {
    zipCode: string
    street: string
    number: string
    complement?: string
    neighborhood: string
    city: string
    state: string
  }
  bankAccount: {
    accountType: string
    bank: string
    agency: string
    account: string
  }
  teamCode?: string
}

export interface CreateSellerResponse {
  _id: string
  name: string
  email: string
  phone: string
  birthDate?: Date
  address: {
    zipCode: string
    street: string
    number: string
    complement?: string
    neighborhood: string
    city: string
    state: string
  }
  bankAccount: {
    accountType: string
    bank: string
    agency: string
    account: string
  }
  isActive: boolean
}

export async function createSeller(body: CreateSellerBody) {
  const { data } = await httpClient.post<CreateSellerResponse>('user', body)
  return data
}
